exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_swiper__XZ51Y {\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 100% !important;\n  /* border: 1px solid red; */\n}\n\n.styles_slide__3PtCS {\n  overflow: hidden !important;\n  flex: 1 0 auto;\n  /* width: 100%; */\n}\n\n.styles_swiper__XZ51Y img {\n  position: absolute;\n  object-fit: cover;\n  max-width: 100%;\n  max-height: 100%;\n  left: -50%;\n  right: -50%;\n  margin: auto;\n  top: -50%;\n  bottom: -50%;\n}", ""]);

// Exports
exports.locals = {
	"swiper": "styles_swiper__XZ51Y",
	"slide": "styles_slide__3PtCS"
};